
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { comparePrimitives, stringHash, equals, int32ToString, createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { collect, exists as exists_1, map as map_2, empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { SignatureDialog } from "../../../Components/SignatureDialog.js";
import { item as item_1, findIndex, indexed, tryHead, sortBy, length, empty as empty_1, contains, filter, tryFind, isEmpty, append as append_1, exists, choose, map, mapIndexed, ofArray, singleton as singleton_1 } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { ProcedureTemplateStepId, FormState_$ctor_240AE3F4, PropertyConfigurationId__get_unwrap, FormState__getValidation, FormState_get_empty } from "../../../Shared/Shared.js";
import { BaseButton, Button, TextButton } from "../../../Components/Button.js";
import { TextValue, PageHeader } from "../../../Components/Text.js";
import { defaultOf } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { toArray, filter as filter_1, bind, unwrap, map as map_1, orElse, defaultArg } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { parse, toLocalTime, toString } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { toString as toString_1, Record } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { ProcedureStepElementResultValue__ResultToString, ProcedureReminderCompletionEntry, ProcedureTemplateStepElementType, PhotoCapture_defaultMaxCount, PhotoCapture_defaultMinCount, ProcedureEmail_submittedUser, ProcedureEmail_submittedAddress, ProcedureEmail_SubmittedRecipient_$reflection, ProcedureEmail_RecipientUser_$reflection, ProcedureEmail_ResolvedRecipientDto_$reflection } from "../../../Shared/Procedure.js";
import { record_type, lambda_type, unit_type, string_type, option_type, list_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { MultiSelect, Select } from "../../../Components/Select.js";
import { NumberInput, Input } from "../../../Components/Input.js";
import { nameOfKey, useDefinitions } from "../../../InventoryStates/Display.js";
import { TextArea } from "../../../Components/TextArea.js";
import { FileType, Msg } from "./Types.js";
import { BoolToggle } from "../../../Components/BoolToggle.js";
import { DatePicker } from "../../../Components/DatePicker.js";
import { DnDFormImage__get_Position, DnDFormImage, LimitedImageUpload } from "../../Image/ImageUploadDnD.js";
import { RadioButtonInGroup } from "../../../Components/RadioButton.js";
import { rangeDouble } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Range.js";
import { Checkbox } from "../../../Components/Checkbox.js";
import { Helper_resolveDisplayValue, CustomProperty, PropertyConfiguration } from "../../../Shared/PropertyConfiguration.js";
import { containsKey, toList as toList_1, ofList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { StringProperty, MultiEnumProperty, EnumProperty, CurrencyProperty, DateProperty, BoolProperty, TextAreaProperty } from "../../CustomProperties.js";
import { Storage__get_DisplayName } from "../../../Shared/Storage.js";
import { unwrapStorageId } from "../../../Shared/Helper.js";
import { toISOString } from "../../../Common.js";
import { parse as parse_1 } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { IconChevronRight, IconCheckmark } from "../../../Components/Icon.js";
import { contains as contains_1, ofList as ofList_1 } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Set.js";
import { SuccessAlert, InformationAlert, WarningAlert } from "../../../Components/Alert.js";
import Check_Circle from "../../../../public/assets/icons/Check_Circle.svg";
import { ConfirmationDialogWithClasses } from "../../../Components/Dialog.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { initTest, update as update_1, init as init_1 } from "./State.js";
import { Skeleton } from "../../../Components/Skeleton.js";
import { ModalSheet } from "../../../Components/ModalSheet.js";

function SignatureInput(props) {
    let elems;
    const patternInput = useTranslation();
    const patternInput_1 = reactApi.useState(false);
    const setIsSignatureDialogOpen = patternInput_1[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems = toList(delay(() => append(singleton(createElement(SignatureDialog, {
        Classes: singleton_1("z-[1100]"),
        Description: props.Label,
        FormState: FormState_get_empty(),
        IsOpen: patternInput_1[0],
        OnClose: () => {
            setIsSignatureDialogOpen(false);
        },
        OnConfirm: (file) => {
            props.OnSetSignature(file);
            setIsSignatureDialogOpen(false);
        },
    })), delay(() => append(singleton(reactElement("label", {
        className: join(" ", ["text-sm", "font-bold"]),
        children: props.Label,
    })), delay(() => {
        let matchValue, signature, imageUrl;
        return append((matchValue = props.SignatureFile, (matchValue == null) ? (empty()) : ((signature = matchValue, (imageUrl = URL.createObjectURL(signature), singleton(reactElement("img", {
            className: join(" ", ["h-24", "border", "rounded"]),
            src: imageUrl,
        })))))), delay(() => append(singleton(createElement(TextButton, {
            ComponentState: props.ComponentState,
            Label: patternInput[0]("notification.sign"),
            OnClick: () => {
                setIsSignatureDialogOpen(true);
            },
            TestId: "procedure-sign-button",
            Variant: "blueButton",
        })), delay(() => {
            const matchValue_1 = props.ValidationMessage;
            if (matchValue_1 == null) {
                return empty();
            }
            else {
                const message = matchValue_1;
                return singleton(reactElement("p", {
                    className: join(" ", ["mt-1", "text-red", "text-sm"]),
                    children: message,
                }));
            }
        }))));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function DescriptionContent(props) {
    let elems;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(PageHeader, {
        Text: props.Dto.Title,
    }), createElement(TextValue, {
        FontWeight: "bold",
        TestId: "",
        Text: props.Dto.Description,
    }), createElement(Button, {
        ComponentState: props.ComponentState,
        Label: patternInput[0]("general.start"),
        OnClick: props.OnStart,
        TestId: "procedure-start-button",
        Variant: "primary",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function StepButtonsContent(props) {
    let elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-5"])], (elems = toList(delay(() => append(singleton(createElement(Button, {
        ComponentState: props.ComponentState,
        Label: t("general.back"),
        OnClick: props.OnBack,
        TestId: "procedure-wizard-back-button",
        Variant: "secondary",
    })), delay(() => append(!props.IsLastStep ? singleton(createElement(Button, {
        ComponentState: props.ComponentState,
        Label: t("general.next"),
        OnClick: props.OnNext,
        TestId: "procedure-wizard-next-button",
        Variant: "primary",
    })) : empty(), delay(() => (props.IsLastStep ? singleton(createElement(Button, {
        ComponentState: props.ComponentState,
        Label: t("general.save"),
        OnClick: props.OnSave,
        TestId: "procedure-wizard-save-button",
        Variant: "primary",
    })) : empty()))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function StepIndicator(props) {
    let elems_1;
    const matchValue = props.CurrentStepIndex;
    if (matchValue == null) {
        return defaultOf();
    }
    else {
        const currentIndex = matchValue | 0;
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "space-x-4"])], (elems_1 = mapIndexed((index, step) => {
            let elems;
            const isCurrentIndex = index === currentIndex;
            return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "items-center", "cursor-pointer"])], (elems = [reactElement("div", {
                onClick: (_arg) => {
                    props.OnClick(index);
                },
                className: join(" ", toList(delay(() => append(singleton("w-10"), delay(() => append(singleton("h-10"), delay(() => append(singleton("flex"), delay(() => append(singleton("items-center"), delay(() => append(singleton("justify-center"), delay(() => append(singleton("rounded-full"), delay(() => append(singleton("border-2"), delay(() => append(singleton("border-gray-400"), delay(() => append(singleton("text-gray-400"), delay(() => (isCurrentIndex ? singleton("text-primary") : empty())))))))))))))))))))))),
                children: int32ToString(index + 1),
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
        }, props.Steps), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    }
}

function ProcedureFormStep(props) {
    return reactElement("div", {
        children: ["todo"],
    });
}

export function emailRecipientLabel(t, recipient) {
    const matchValue = recipient.Kind;
    switch (matchValue.tag) {
        case 1:
            return defaultArg(orElse(recipient.Name, recipient.UserId), "");
        case 2:
            return t("procedure.send_email.recipient_storage_managers");
        case 3:
            return t("procedure.send_email.recipient_performer_self");
        default:
            return defaultArg(recipient.Address, "");
    }
}

export function SendEmailDispatch(props) {
    let elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["data-test-id", concat("procedure-send-email-dispatch-", ...props.Element.Label)], ["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems = toList(delay(() => {
        const matchValue = props.Dispatch;
        if (matchValue == null) {
            return singleton(reactElement("div", {
                className: join(" ", ["text-lg"]),
                children: props.IsTestMode ? t("procedure.send_email.not_sent_test") : "-",
            }));
        }
        else {
            const dispatch = matchValue;
            return append((dispatch.Status.tag === 1) ? singleton(reactElement("div", {
                className: join(" ", ["text-lg"]),
                children: t("procedure.send_email.status_no_recipients"),
            })) : singleton(reactElement("div", {
                className: join(" ", ["text-lg"]),
                children: (t("procedure.send_email.status_queued") + " ") + join(", ", dispatch.Recipients),
            })), delay(() => append(dispatch.RecipientsChanged ? singleton(reactElement("div", {
                "data-test-id": concat("procedure-send-email-recipients-changed-", ...props.Element.Label),
                className: join(" ", ["text-sm", "text-gray-500"]),
                children: t("procedure.send_email.recipients_changed"),
            })) : empty(), delay(() => singleton(reactElement("div", {
                className: join(" ", ["text-sm", "text-gray-500"]),
                children: (t("procedure.send_email.sent_at") + ": ") + toString(toLocalTime(dispatch.SentAt), "dd.MM.yyyy HH:mm"),
            }))))));
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export class EditableEmailRecipients extends Record {
    constructor(Resolved, Users, Current, ValidationMessage, ComponentState, OnChange) {
        super();
        this.Resolved = Resolved;
        this.Users = Users;
        this.Current = Current;
        this.ValidationMessage = ValidationMessage;
        this.ComponentState = ComponentState;
        this.OnChange = OnChange;
    }
}

export function EditableEmailRecipients_$reflection() {
    return record_type("Widgets.Procedure.Form.View.EditableEmailRecipients", [], EditableEmailRecipients, () => [["Resolved", list_type(ProcedureEmail_ResolvedRecipientDto_$reflection())], ["Users", list_type(ProcedureEmail_RecipientUser_$reflection())], ["Current", option_type(list_type(ProcedureEmail_SubmittedRecipient_$reflection()))], ["ValidationMessage", option_type(string_type)], ["ComponentState", string_type], ["OnChange", lambda_type(list_type(ProcedureEmail_SubmittedRecipient_$reflection()), unit_type)]]);
}

export function SendEmailRecipientEditor(props) {
    let elems_4;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState("");
    const setNewAddress = patternInput_1[1];
    const newAddress = patternInput_1[0];
    let recipients;
    const matchValue = props.Recipients.Current;
    recipients = ((matchValue == null) ? map((recipient) => {
        const matchValue_1 = recipient.UserId;
        if (matchValue_1 == null) {
            return ProcedureEmail_submittedAddress(recipient.Address);
        }
        else {
            return ProcedureEmail_submittedUser(matchValue_1);
        }
    }, props.Recipients.Resolved) : matchValue);
    const recipientKey = (recipient_2) => {
        const matchValue_5 = recipient_2.UserId;
        const matchValue_6 = recipient_2.Address;
        if (matchValue_5 == null) {
            if (matchValue_6 == null) {
                return "";
            }
            else {
                return matchValue_6;
            }
        }
        else {
            return matchValue_5;
        }
    };
    const selectedUserIds = choose((_arg) => _arg.UserId, recipients);
    const addAddress = () => {
        const address_3 = newAddress.trim();
        if ((address_3 !== "") && !exists((recipient_3) => {
            const matchValue_8 = recipient_3.Address;
            if (matchValue_8 == null) {
                return false;
            }
            else {
                const existing = matchValue_8;
                return existing.toLowerCase() === address_3.toLowerCase();
            }
        }, recipients)) {
            props.Recipients.OnChange(append_1(recipients, singleton_1(ProcedureEmail_submittedAddress(address_3))));
        }
        setNewAddress("");
    };
    const isDisabled = props.Recipients.ComponentState === "disabled";
    return reactElement("div", createObj(ofArray([["data-test-id", concat("procedure-send-email-recipients-", ...props.Element.Label)], ["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_4 = toList(delay(() => {
        let elems_1;
        return append(isEmpty(recipients) ? singleton(reactElement("div", {
            className: join(" ", ["text-sm", "text-text-muted"]),
            children: t("procedure.send_email.no_recipients_selected"),
        })) : singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-2"])], (elems_1 = toList(delay(() => map((recipient_4) => {
            let elems, recipient_1, matchValue_2, matchValue_3, userId_1;
            return reactElement("span", createObj(ofArray([["data-test-id", concat("procedure-send-email-recipient-", ...recipientKey(recipient_4))], ["className", join(" ", ["flex", "items-center", "gap-1", "rounded-xl", "bg-white", "px-2.5", "py-1", "text-sm"])], (elems = [reactElement("span", {
                children: (recipient_1 = recipient_4, (matchValue_2 = recipient_1.UserId, (matchValue_3 = recipient_1.Address, (matchValue_2 == null) ? ((matchValue_3 == null) ? "" : matchValue_3) : ((userId_1 = matchValue_2, defaultArg(orElse(map_1((user_1) => concat(user_1.Name, " (", user_1.Address, ...")"), tryFind((user) => (user.UserId === userId_1), props.Recipients.Users)), map_1((resolved_1) => (defaultArg(resolved_1.Name, resolved_1.Address) + concat(" (", resolved_1.Address, ...")")), tryFind((resolved) => equals(resolved.UserId, userId_1), props.Recipients.Resolved))), userId_1)))))),
            }), reactElement("button", {
                "data-test-id": concat("procedure-send-email-remove-", ...recipientKey(recipient_4)),
                type: "button",
                disabled: isDisabled,
                className: join(" ", ["text-text-muted", "hover:text-black"]),
                children: "×",
                onClick: (_arg_1) => {
                    props.Recipients.OnChange(filter((existing_1) => (recipientKey(existing_1) !== recipientKey(recipient_4)), recipients));
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
        }, recipients))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => append(singleton(createElement(Select, {
            ComponentState: props.Recipients.ComponentState,
            IsClearable: false,
            Label: t("procedure.send_email.add_user"),
            NoOptionsMessage: "procedure.send_email.no_users",
            OnChange: (selected) => {
                if (selected == null) {
                }
                else {
                    props.Recipients.OnChange(append_1(recipients, singleton_1(ProcedureEmail_submittedUser(selected.value))));
                }
            },
            Options: map((user_3) => ({
                label: concat(user_3.Name, " (", user_3.Address, ...")"),
                value: user_3.UserId,
            }), filter((user_2) => !contains(user_2.UserId, selectedUserIds, {
                Equals: (x, y) => (x === y),
                GetHashCode: (x) => (stringHash(x) | 0),
            }), props.Recipients.Users)),
            PlaceholderKey: "procedure.send_email.select_users",
            TestId: concat("procedure-send-email-add-user-", ...props.Element.Label),
        })), delay(() => {
            let elems_3, elems_2;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-end", "gap-2"])], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex-grow"])], ["onKeyDown", (event) => {
                if (event.key === "Enter") {
                    event.preventDefault();
                    addAddress();
                }
            }], (elems_2 = [createElement(Input, {
                ComponentState: props.Recipients.ComponentState,
                Label: t("procedure.send_email.recipient_addresses"),
                OnChange: setNewAddress,
                TestId: concat("procedure-send-email-address-", ...props.Element.Label),
                Value: newAddress,
            })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement(TextButton, {
                ComponentState: props.Recipients.ComponentState,
                Label: t("procedure.send_email.add_address"),
                OnClick: addAddress,
                TestId: concat("procedure-send-email-add-address-", ...props.Element.Label),
                Variant: "blueButton",
            })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                const matchValue_9 = props.Recipients.ValidationMessage;
                if (matchValue_9 == null) {
                    return empty();
                }
                else {
                    const message = matchValue_9;
                    return singleton(reactElement("div", {
                        "data-test-id": concat("procedure-send-email-validation-", ...props.Element.Label),
                        className: join(" ", ["text-red", "text-sm"]),
                        children: message,
                    }));
                }
            }));
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

export function SendEmailNotice(props) {
    let elems_4, elems;
    const t = useTranslation()[0];
    if (props.Dispatch == null) {
        return reactElement("div", createObj(ofArray([["data-test-id", concat("procedure-send-email-", ...props.Element.Label)], ["className", join(" ", ["flex", "flex-col", "gap-2", "p-3", "bg-gray-100", "rounded"])], (elems_4 = toList(delay(() => append(singleton(reactElement("label", {
            className: join(" ", ["text-sm", "font-bold"]),
            children: props.Element.Label,
        })), delay(() => {
            let matchValue_1, recipients, recipients_1;
            return append((matchValue_1 = props.EditableRecipients, (matchValue_1 != null) ? (((recipients = matchValue_1, !props.IsTestMode)) ? ((recipients_1 = matchValue_1, append(singleton(reactElement("div", {
                className: join(" ", ["text-sm"]),
                children: t("procedure.send_email.editable_notice"),
            })), delay(() => singleton(createElement(SendEmailRecipientEditor, {
                Element: props.Element,
                Recipients: recipients_1,
            })))))) : append(singleton(reactElement("div", {
                className: join(" ", ["text-sm"]),
                children: props.IsTestMode ? t("procedure.send_email.test_notice") : t("procedure.send_email.notice"),
            })), delay(() => {
                let elems_1;
                return singleton(reactElement("ul", createObj(ofArray([["data-test-id", concat("procedure-send-email-recipients-", ...props.Element.Label)], ["className", join(" ", ["list-disc", "pl-5", "text-sm"])], (elems_1 = toList(delay(() => map((recipient) => reactElement("li", {
                    children: emailRecipientLabel(t, recipient),
                }), props.Element.EmailRecipients))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
            }))) : append(singleton(reactElement("div", {
                className: join(" ", ["text-sm"]),
                children: props.IsTestMode ? t("procedure.send_email.test_notice") : t("procedure.send_email.notice"),
            })), delay(() => {
                let elems_1;
                return singleton(reactElement("ul", createObj(ofArray([["data-test-id", concat("procedure-send-email-recipients-", ...props.Element.Label)], ["className", join(" ", ["list-disc", "pl-5", "text-sm"])], (elems_1 = toList(delay(() => map((recipient) => reactElement("li", {
                    children: emailRecipientLabel(t, recipient),
                }), props.Element.EmailRecipients))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
            }))), delay(() => {
                let elems_3, elems_2;
                return props.IsTestMode ? singleton(reactElement("div", createObj(ofArray([["data-test-id", concat("procedure-send-email-preview-", ...props.Element.Label)], ["className", join(" ", ["flex", "flex-col", "gap-1", "text-sm", "border-t", "border-gray-300", "pt-2"])], (elems_3 = [reactElement("div", createObj(singleton_1((elems_2 = [reactElement("span", {
                    className: join(" ", ["font-bold"]),
                    children: t("procedure.send_email.subject") + ": ",
                }), reactElement("span", {
                    children: props.Element.EmailSubject,
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])))), reactElement("div", {
                    className: join(" ", ["whitespace-pre-wrap", "break-words"]),
                    children: props.Element.EmailBody,
                })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))) : empty();
            }));
        })))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
    }
    else {
        return reactElement("div", createObj(ofArray([["data-test-id", concat("procedure-send-email-", ...props.Element.Label)], ["className", join(" ", ["flex", "flex-col", "gap-1", "p-3", "bg-gray-100", "rounded"])], (elems = [reactElement("label", {
            className: join(" ", ["text-sm", "font-bold"]),
            children: props.Element.Label,
        }), createElement(SendEmailDispatch, {
            Dispatch: unwrap(props.Dispatch),
            Element: props.Element,
            IsTestMode: props.IsTestMode,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
}

function StepHeader(props) {
    let elems;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1.5"])], (elems = toList(delay(() => {
        let arg_1;
        return append(singleton(reactElement("span", {
            className: join(" ", ["text-sm", "font-semibold", "text-primary-link"]),
            "data-test-id": "procedure-step-position",
            children: (arg_1 = {
                current: props.StepNumber,
                total: props.StepCount,
            }, patternInput[1].t("procedure.step_position", arg_1)),
        })), delay(() => append(singleton(reactElement("h2", {
            className: join(" ", ["text-lg", "font-bold", "break-words"]),
            children: props.Name,
        })), delay(() => ((props.Description !== "") ? singleton(reactElement("p", {
            className: join(" ", ["text-sm", "whitespace-pre-wrap", "break-words"]),
            children: props.Description,
        })) : empty())))));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function StepFooter(buttons) {
    let elems_1;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["sticky", "bottom-0", "mt-auto", "bg-white", "px-4", "pt-3", "pb-4"])], (elems_1 = [reactElement("div", {
        className: join(" ", ["flex", "justify-end", "gap-5", "max-w-[49rem]"]),
        children: reactApi.Children.toArray(Array.from(buttons)),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function ProcedureStepForm(props) {
    let elems_24, elems_23, elems_22;
    const t = useTranslation()[0];
    const inventoryStates = useDefinitions();
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "grow"])], (elems_24 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-6", "w-full", "max-w-[51rem]", "px-4", "py-6"])], (elems_23 = [createElement(StepHeader, {
        Description: props.ProcedureTemplateStep.Description,
        Name: props.ProcedureTemplateStep.Name,
        StepCount: props.StepCount,
        StepNumber: props.StepNumber,
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-5"])], (elems_22 = toList(delay(() => map((procedureTemplateStepElement) => {
        let Value_1, ValidationMessage, Value_2, ValidationMessage_1, Value_3, ValidationMessage_2, YesLabel, NoLabel, Value_4, ValidationMessage_3, Value_5, ValidationMessage_4, elems_1, elems_2, elems_3, Options, Value_6, ValidationMessage_5, Options_1, Value_7, ValidationMessage_6, elems_10, Options_2, Value_8, ValidationMessage_7, elems_9, matchValue_5, elems_11, elems_12, Label_20, Value_11, elems_15, elems_21, Value;
        const currentResult = tryFind((result) => (result.ProcedureTemplateStepElementId === procedureTemplateStepElement.Id), props.WriteProcedureStepDto.Results);
        const matchValue = procedureTemplateStepElement.Type;
        switch (matchValue.tag) {
            case 1:
                return createElement(TextArea, (Value_1 = defaultArg(bind((_arg_1) => _arg_1.TextValue, currentResult), ""), (ValidationMessage = FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id), {
                    ComponentState: componentState,
                    Label: procedureTemplateStepElement.Label,
                    OnChange: (value_6) => {
                        props.Dispatch(new Msg(0, [procedureTemplateStepElement.Id, value_6]));
                    },
                    TestId: concat("procedure-element-", ...procedureTemplateStepElement.Label),
                    ValidationMessage: unwrap(ValidationMessage),
                    Value: Value_1,
                })));
            case 3:
                return createElement(NumberInput, (Value_2 = map_1((value_7) => value_7, bind((_arg_2) => _arg_2.IntNumberValue, currentResult)), (ValidationMessage_1 = FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id), {
                    ComponentState: componentState,
                    Label: procedureTemplateStepElement.Label,
                    OnChange: (value_8) => {
                        props.Dispatch(new Msg(1, [procedureTemplateStepElement.Id, defaultArg(map_1((value_9) => (~~value_9 | 0), value_8), 0)]));
                    },
                    TestId: concat("procedure-element-", ...procedureTemplateStepElement.Label),
                    ValidationMessage: unwrap(ValidationMessage_1),
                    Value: unwrap(Value_2),
                })));
            case 4:
                return createElement(NumberInput, (Value_3 = bind((_arg_3) => _arg_3.FloatNumberValue, currentResult), (ValidationMessage_2 = FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id), {
                    ComponentState: componentState,
                    Label: procedureTemplateStepElement.Label,
                    OnChange: (value_11) => {
                        props.Dispatch(new Msg(2, [procedureTemplateStepElement.Id, value_11]));
                    },
                    TestId: concat("procedure-element-", ...procedureTemplateStepElement.Label),
                    ValidationMessage: unwrap(ValidationMessage_2),
                    Value: unwrap(Value_3),
                })));
            case 5:
                return createElement(BoolToggle, (YesLabel = t("general.yes"), (NoLabel = t("general.no"), (Value_4 = bind((_arg_4) => _arg_4.BoolValue, currentResult), (ValidationMessage_3 = FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id), {
                    ComponentState: componentState,
                    Label: procedureTemplateStepElement.Label,
                    NoLabel: NoLabel,
                    OnChange: (value_12) => {
                        props.Dispatch(new Msg(3, [procedureTemplateStepElement.Id, value_12]));
                    },
                    TestId: concat("procedure-element-", ...procedureTemplateStepElement.Label),
                    ValidationMessage: unwrap(ValidationMessage_3),
                    Value: unwrap(Value_4),
                    YesLabel: YesLabel,
                })))));
            case 6:
                return createElement(DatePicker, (Value_5 = bind((_arg_5) => _arg_5.DateTimeValue, currentResult), (ValidationMessage_4 = FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id), {
                    ComponentState: componentState,
                    IsClearable: true,
                    Label: procedureTemplateStepElement.Label,
                    OnChange: (value_13) => {
                        props.Dispatch(new Msg(6, [procedureTemplateStepElement.Id, value_13]));
                    },
                    TestId: concat("procedure-element-", ...procedureTemplateStepElement.Label),
                    ValidationMessage: unwrap(ValidationMessage_4),
                    Value: unwrap(Value_5),
                })));
            case 2:
                return reactElement("div", {
                    className: join(" ", ["p-3", "bg-gray-100", "rounded", "whitespace-pre-wrap", "break-words"]),
                    children: procedureTemplateStepElement.Label,
                });
            case 12:
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_1 = toList(delay(() => append((procedureTemplateStepElement.Label !== "") ? singleton(reactElement("div", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: procedureTemplateStepElement.Label,
                })) : empty(), delay(() => {
                    let elems;
                    return !isEmpty(procedureTemplateStepElement.Options) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-2"])], (elems = toList(delay(() => map((imageUrl) => reactElement("img", {
                        className: join(" ", ["rounded", "border", "max-w-full", "max-h-48", "object-contain"]),
                        src: imageUrl,
                    }), procedureTemplateStepElement.Options))), ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
                })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
            case 13: {
                const photoFiles = defaultArg(map_1((_arg_6) => _arg_6.Files, tryFind((entry) => (entry.ElementId === procedureTemplateStepElement.Id), props.PhotoUploads)), empty_1());
                const minCount = defaultArg(procedureTemplateStepElement.MinCount, PhotoCapture_defaultMinCount) | 0;
                const maxCount = defaultArg(procedureTemplateStepElement.MaxCount, PhotoCapture_defaultMaxCount) | 0;
                const photosLabel = t("procedure.photo_capture.photos");
                const minLabel = t("procedure.photo_capture.min_count");
                const countText = `${length(photoFiles)} / ${maxCount} ${photosLabel} (${minLabel}: ${minCount})`;
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], ["data-test-id", concat("procedure-element-", ...procedureTemplateStepElement.Label)], (elems_2 = toList(delay(() => append(singleton(reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: procedureTemplateStepElement.Label,
                })), delay(() => {
                    let SelectedFiles, Label_6, OpenTestId;
                    return append(singleton(createElement(LimitedImageUpload, (SelectedFiles = mapIndexed((index, photoFile) => (new DnDFormImage(0, [{
                        File: photoFile.File,
                        Position: index + 1,
                    }])), photoFiles), (Label_6 = t("procedure.photo_capture.add_photo"), (OpenTestId = concat("procedure-add-photo-", procedureTemplateStepElement.Label, ..."-button"), {
                        ComponentState: componentState,
                        InputTestId: concat("procedure-photo-input-", ...procedureTemplateStepElement.Label),
                        Label: Label_6,
                        MaxCount: maxCount,
                        OpenTestId: OpenTestId,
                        PreviewTestId: concat("procedure-photo-preview-", ...procedureTemplateStepElement.Label),
                        RemoveTestId: concat("procedure-remove-photo-", ...procedureTemplateStepElement.Label),
                        SelectedFiles: SelectedFiles,
                        SetSelectedFile: (images) => {
                            props.Dispatch(new Msg(29, [procedureTemplateStepElement.Id, choose((image) => {
                                if (image.tag === 1) {
                                    return undefined;
                                }
                                else {
                                    return image.fields[0].File;
                                }
                            }, sortBy((_arg_7) => (DnDFormImage__get_Position(_arg_7) | 0), images, {
                                Compare: (x, y) => (comparePrimitives(x, y) | 0),
                            }))]));
                        },
                    }))))), delay(() => append(singleton(reactElement("div", {
                        className: join(" ", ["text-sm", "text-text-muted"]),
                        "data-test-id": concat("procedure-photo-count-", ...procedureTemplateStepElement.Label),
                        children: countText,
                    })), delay(() => {
                        const matchValue_1 = FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id);
                        if (matchValue_1 == null) {
                            return empty();
                        }
                        else {
                            const msg = matchValue_1;
                            return singleton(reactElement("p", {
                                className: join(" ", ["mt-1", "text-red", "text-sm"]),
                                children: msg,
                            }));
                        }
                    }))));
                })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
            }
            case 7:
                return reactElement("div", {
                    className: join(" ", ["p-3", "bg-gray-100", "rounded"]),
                    children: procedureTemplateStepElement.Label,
                });
            case 8:
                return createElement(SignatureInput, {
                    ComponentState: componentState,
                    ElementId: procedureTemplateStepElement.Id,
                    Label: procedureTemplateStepElement.Label,
                    OnSetSignature: (file_1) => {
                        props.Dispatch(new Msg(27, [procedureTemplateStepElement.Id, file_1, new FileType(0, [])]));
                    },
                    SignatureFile: unwrap(bind((sf_1) => tryHead(sf_1.Files), tryFind((sf) => {
                        if (sf.StepId === procedureTemplateStepElement.Id) {
                            return equals(sf.Type, new FileType(0, []));
                        }
                        else {
                            return false;
                        }
                    }, props.StepFiles))),
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id)),
                });
            case 11: {
                const currentSelectValue = bind((_arg_8) => _arg_8.SingleSelectValue, currentResult);
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], ["data-test-id", concat("procedure-element-", ...procedureTemplateStepElement.Label)], (elems_3 = toList(delay(() => append(singleton(reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: procedureTemplateStepElement.Label,
                })), delay(() => append(map((opt) => createElement(RadioButtonInGroup, {
                    ComponentState: componentState,
                    Group: procedureTemplateStepElement.Id,
                    Label: opt,
                    OnSelect: (_arg_9) => {
                        props.Dispatch(new Msg(4, [procedureTemplateStepElement.Id, {
                            label: opt,
                            value: opt,
                        }, new ProcedureTemplateStepElementType(11, [])]));
                    },
                    Selected: equals(currentSelectValue, opt),
                }), procedureTemplateStepElement.Options), delay(() => {
                    const matchValue_2 = FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id);
                    if (matchValue_2 == null) {
                        return empty();
                    }
                    else {
                        const msg_1 = matchValue_2;
                        return singleton(reactElement("p", {
                            className: join(" ", ["mt-1", "text-red", "text-sm"]),
                            children: msg_1,
                        }));
                    }
                })))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
            }
            case 9: {
                const currentSelectValue_1 = bind((_arg_10) => _arg_10.SingleSelectValue, currentResult);
                return createElement(Select, (Options = map((opt_1) => ({
                    label: opt_1,
                    value: opt_1,
                }), procedureTemplateStepElement.Options), (Value_6 = map_1((v) => ({
                    label: v,
                    value: v,
                }), currentSelectValue_1), (ValidationMessage_5 = FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id), {
                    ComponentState: componentState,
                    IsClearable: true,
                    Label: procedureTemplateStepElement.Label,
                    NoOptionsMessage: "",
                    OnChange: (value_56) => {
                        props.Dispatch(new Msg(4, [procedureTemplateStepElement.Id, value_56, new ProcedureTemplateStepElementType(9, [])]));
                    },
                    Options: Options,
                    PlaceholderKey: "general.select",
                    TestId: concat("procedure-element-", ...procedureTemplateStepElement.Label),
                    ValidationMessage: unwrap(ValidationMessage_5),
                    Value: unwrap(Value_6),
                }))));
            }
            case 10: {
                const currentMultiValues = defaultArg(bind((_arg_11) => _arg_11.MultiSelectValue, currentResult), empty_1());
                return createElement(MultiSelect, (Options_1 = map((opt_2) => ({
                    label: opt_2,
                    value: opt_2,
                }), procedureTemplateStepElement.Options), (Value_7 = map((v_1) => ({
                    label: v_1,
                    value: v_1,
                }), currentMultiValues), (ValidationMessage_6 = FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id), {
                    ComponentState: componentState,
                    IsClearable: true,
                    Label: procedureTemplateStepElement.Label,
                    NoOptionsMessage: "",
                    OnChange: (value_58) => {
                        props.Dispatch(new Msg(5, [procedureTemplateStepElement.Id, value_58]));
                    },
                    Options: Options_1,
                    PlaceholderKey: "general.select",
                    TestId: concat("procedure-element-", ...procedureTemplateStepElement.Label),
                    ValidationMessage: unwrap(ValidationMessage_6),
                    Value: Value_7,
                }))));
            }
            case 14: {
                const currentInspectionResultValue = bind((_arg_12) => _arg_12.InspectionResultValue, currentResult);
                const currentComment = defaultArg(bind((_arg_13) => _arg_13.InspectionResultComment, currentResult), "");
                const elementDocuments = defaultArg(map_1((_arg_14) => _arg_14.Files, tryFind((entry_1) => (entry_1.ElementId === procedureTemplateStepElement.Id), props.InspectionDocuments)), empty_1());
                const fileUploadId = concat("inspection-doc-upload-", ...procedureTemplateStepElement.Id);
                let inspectionLabel;
                const matchValue_3 = procedureTemplateStepElement.InspectionTemplateName;
                inspectionLabel = ((matchValue_3 == null) ? procedureTemplateStepElement.Label : concat(procedureTemplateStepElement.Label, " (", matchValue_3, ...")"));
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems_10 = [createElement(Select, (Options_2 = map((opt_3) => ({
                    label: opt_3,
                    value: opt_3,
                }), procedureTemplateStepElement.Options), (Value_8 = map_1((v_2) => ({
                    label: v_2,
                    value: v_2,
                }), currentInspectionResultValue), (ValidationMessage_7 = FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id), {
                    ComponentState: componentState,
                    IsClearable: true,
                    Label: inspectionLabel,
                    NoOptionsMessage: "",
                    OnChange: (value_62) => {
                        props.Dispatch(new Msg(7, [procedureTemplateStepElement.Id, value_62]));
                    },
                    Options: Options_2,
                    PlaceholderKey: "general.select",
                    TestId: concat("inspection-result-", procedureTemplateStepElement.Label, ..."-select"),
                    ValidationMessage: unwrap(ValidationMessage_7),
                    Value: unwrap(Value_8),
                })))), createElement(TextArea, {
                    ComponentState: componentState,
                    Label: t("inspection_result.comment"),
                    OnChange: (value_63) => {
                        props.Dispatch(new Msg(8, [procedureTemplateStepElement.Id, value_63]));
                    },
                    TestId: concat("inspection-result-", procedureTemplateStepElement.Label, ..."-comment-textarea"),
                    Value: currentComment,
                }), reactElement("div", createObj(singleton_1((elems_9 = toList(delay(() => append(singleton(reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold", "mb-2", "block"]),
                    children: t("inspection_result.document_upload"),
                })), delay(() => {
                    let elems_4;
                    return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "justify-center", "items-center", "rounded-lg", "border", "border-dashed", "border-primary", "p-4"])], ["onDragOver", (e) => {
                        e.preventDefault();
                    }], ["onDrop", (e_1) => {
                        e_1.preventDefault();
                        if (!props.FormState.IsLoading) {
                            props.Dispatch(new Msg(17, [procedureTemplateStepElement.Id, toList(delay(() => map_2((i) => e_1.dataTransfer.files.item(i), rangeDouble(0, 1, e_1.dataTransfer.files.length - 1))))]));
                        }
                    }], (elems_4 = [createElement(TextButton, {
                        ComponentState: componentState,
                        Label: t("file_upload.select_file"),
                        OnClick: () => {
                            const element = document.getElementById(fileUploadId);
                            element.click();
                        },
                        TestId: concat("procedure-select-file-", procedureTemplateStepElement.Label, ..."-button"),
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => append(singleton(reactElement("input", {
                        id: fileUploadId,
                        className: join(" ", ["hidden"]),
                        type: "file",
                        multiple: true,
                        disabled: props.FormState.IsLoading,
                        onChange: (ev) => {
                            const fileList = ev.target.files;
                            if (!(fileList == null)) {
                                props.Dispatch(new Msg(17, [procedureTemplateStepElement.Id, toList(delay(() => map_2((i_1) => fileList.item(i_1), rangeDouble(0, 1, fileList.length - 1))))]));
                            }
                        },
                    })), delay(() => {
                        let elems_8;
                        return !isEmpty(elementDocuments) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3", "mt-2"])], (elems_8 = toList(delay(() => map((tupledArg) => {
                            let elems_7, elems_5, elems_6;
                            const index_1 = tupledArg[0] | 0;
                            const docFile = tupledArg[1];
                            return reactElement("div", createObj(ofArray([["className", join(" ", ["rounded-md", "border", "border-border", "p-3"])], (elems_7 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-between", "mb-2"])], (elems_5 = [reactElement("span", {
                                className: join(" ", ["text-sm", "truncate", "font-medium"]),
                                children: docFile.File.name,
                            }), reactElement("button", {
                                className: join(" ", ["text-gray-400", "hover:text-red", "cursor-pointer", "ml-2", "flex-shrink-0", "disabled:opacity-50", "disabled:cursor-not-allowed"]),
                                type: "button",
                                disabled: props.FormState.IsLoading,
                                onClick: (e_2) => {
                                    e_2.preventDefault();
                                    e_2.stopPropagation();
                                    props.Dispatch(new Msg(18, [procedureTemplateStepElement.Id, index_1]));
                                },
                                children: "✕",
                            })], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-2"])], (elems_6 = [createElement(Input, {
                                ComponentState: componentState,
                                Label: t("general.name"),
                                OnChange: (v_3) => {
                                    props.Dispatch(new Msg(19, [procedureTemplateStepElement.Id, index_1, v_3]));
                                },
                                TestId: `document-name-input-${procedureTemplateStepElement.Label}-${index_1}`,
                                Value: docFile.Name,
                            }), createElement(Input, {
                                ComponentState: componentState,
                                Label: t("general.description"),
                                OnChange: (v_4) => {
                                    props.Dispatch(new Msg(20, [procedureTemplateStepElement.Id, index_1, v_4]));
                                },
                                TestId: `document-description-input-${procedureTemplateStepElement.Label}-${index_1}`,
                                Value: docFile.Description,
                            }), Checkbox({
                                ComponentState: componentState,
                                IsChecked: docFile.IsVisibleForUserRole,
                                Label: t("tool.document_visible_for_user_role"),
                                OnCheck: (_arg_16) => {
                                    props.Dispatch(new Msg(21, [procedureTemplateStepElement.Id, index_1]));
                                },
                                TestId: `document-visible-for-user-checkbox-${procedureTemplateStepElement.Label}-${index_1}`,
                            })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
                        }, indexed(elementDocuments)))), ["children", reactApi.Children.toArray(Array.from(elems_8))])])))) : empty();
                    }))));
                })))), ["children", reactApi.Children.toArray(Array.from(elems_9))]))))], ["children", reactApi.Children.toArray(Array.from(elems_10))])])));
            }
            case 16: {
                const propertyConfiguration = bind((id) => tryFind((pc) => (PropertyConfigurationId__get_unwrap(pc.Id) === id), props.PropertyConfigurations), procedureTemplateStepElement.PropertyConfigurationId);
                const currentValue = defaultArg(bind((_arg_17) => _arg_17.CustomFieldValue, currentResult), "");
                const dispatchValue = (value_103) => {
                    props.Dispatch(new Msg(9, [procedureTemplateStepElement.Id, value_103]));
                };
                if (propertyConfiguration != null) {
                    const configuration = propertyConfiguration;
                    const displayConfiguration = new PropertyConfiguration(configuration.Id, procedureTemplateStepElement.Label, configuration.Required, configuration.IsDeleted, configuration.Type, configuration.Visibility, configuration.CreatedAt, configuration.UpdatedAt);
                    const propertyId = PropertyConfigurationId__get_unwrap(configuration.Id);
                    const widgetFormState = FormState_$ctor_240AE3F4(ofList(map((tupledArg_1) => {
                        const key_66 = tupledArg_1[0];
                        const value_104 = tupledArg_1[1];
                        if (key_66 === procedureTemplateStepElement.Id) {
                            return [concat("custom-property-", ...propertyId), value_104];
                        }
                        else {
                            return [key_66, value_104];
                        }
                    }, toList_1(props.FormState.Validations)), {
                        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
                    }), props.FormState.IsLoading);
                    const currentCustomProperty = (currentValue === "") ? undefined : (new CustomProperty(propertyId, currentValue));
                    const onSetCustomProperties = (properties_24) => {
                        dispatchValue(defaultArg(map_1((_arg_18) => _arg_18.Value, tryFind((p) => (p.Id === propertyId), properties_24)), ""));
                    };
                    const customProperties = defaultArg(map_1(singleton_1, currentCustomProperty), empty_1());
                    const matchValue_4 = configuration.Type;
                    switch (matchValue_4.tag) {
                        case 1:
                            return createElement(TextAreaProperty, {
                                CustomProperties: customProperties,
                                FormState: widgetFormState,
                                OnSetCustomProperties: onSetCustomProperties,
                                Property: displayConfiguration,
                                TestId: "",
                                Value: unwrap(currentCustomProperty),
                            });
                        case 5:
                            return createElement(BoolProperty, {
                                CustomProperties: customProperties,
                                FormState: widgetFormState,
                                OnSetCustomProperties: onSetCustomProperties,
                                Property: displayConfiguration,
                                TestId: "",
                                Value: unwrap(currentCustomProperty),
                            });
                        case 4:
                            return createElement(DateProperty, {
                                CustomProperties: customProperties,
                                FormState: widgetFormState,
                                OnSetCustomProperties: onSetCustomProperties,
                                Property: displayConfiguration,
                                TestId: "",
                                Value: unwrap(currentCustomProperty),
                            });
                        case 7:
                            return createElement(CurrencyProperty, {
                                Currency: (matchValue_5 = props.CustomerConfiguration, (matchValue_5.tag === 1) ? matchValue_5.fields[0].Currency : "eUR"),
                                CustomProperties: customProperties,
                                FormState: widgetFormState,
                                OnSetCustomProperties: onSetCustomProperties,
                                Property: displayConfiguration,
                                TestId: "",
                                Value: unwrap(currentCustomProperty),
                            });
                        case 2:
                            return createElement(EnumProperty, {
                                CustomProperties: customProperties,
                                FormState: widgetFormState,
                                OnSetCustomProperties: onSetCustomProperties,
                                Property: displayConfiguration,
                                TestId: "",
                                Value: unwrap(currentCustomProperty),
                            });
                        case 3:
                            return createElement(MultiEnumProperty, {
                                CustomProperties: customProperties,
                                FormState: widgetFormState,
                                OnSetCustomProperties: onSetCustomProperties,
                                Property: displayConfiguration,
                                TestId: "",
                                Value: unwrap(currentCustomProperty),
                            });
                        default:
                            return createElement(StringProperty, {
                                CustomProperties: customProperties,
                                FormState: widgetFormState,
                                OnSetCustomProperties: onSetCustomProperties,
                                Property: displayConfiguration,
                                TestId: "",
                                Value: unwrap(currentCustomProperty),
                            });
                    }
                }
                else {
                    return createElement(Input, {
                        ComponentState: componentState,
                        Label: procedureTemplateStepElement.Label,
                        OnChange: dispatchValue,
                        TestId: concat("procedure-element-", ...procedureTemplateStepElement.Label),
                        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id)),
                        Value: currentValue,
                    });
                }
            }
            case 17: {
                const currentValue_1 = bind((_arg_19) => _arg_19.ToolStateChangeValue, currentResult);
                const currentComment_1 = defaultArg(bind((_arg_20) => _arg_20.ToolStateChangeComment, currentResult), "");
                const hasExplicitChoice = defaultArg(map_1((r) => equals(r.Type, new ProcedureTemplateStepElementType(17, [])), currentResult), false);
                const isNoChangeSelected = ((currentValue_1 == null) && hasExplicitChoice) ? true : !hasExplicitChoice;
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_11 = toList(delay(() => append(singleton(reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: procedureTemplateStepElement.Label,
                })), delay(() => append(singleton(createElement(RadioButtonInGroup, {
                    ComponentState: componentState,
                    Group: procedureTemplateStepElement.Id,
                    Label: t("procedure.tool_state_change.no_change"),
                    OnSelect: (_arg_21) => {
                        props.Dispatch(new Msg(10, [procedureTemplateStepElement.Id, undefined]));
                    },
                    Selected: isNoChangeSelected,
                })), delay(() => append(map((state) => {
                    const isCurrentToolState = equals(props.CurrentToolStateKey, state);
                    return createElement(RadioButtonInGroup, {
                        ComponentState: isCurrentToolState ? "disabled" : componentState,
                        Group: procedureTemplateStepElement.Id,
                        Label: nameOfKey(t, inventoryStates, state),
                        OnSelect: (_arg_22) => {
                            if (!isCurrentToolState) {
                                props.Dispatch(new Msg(10, [procedureTemplateStepElement.Id, state]));
                            }
                        },
                        Selected: equals(currentValue_1, state),
                    });
                }, procedureTemplateStepElement.Options), delay(() => append((currentValue_1 != null) ? singleton(createElement(TextArea, {
                    ComponentState: componentState,
                    Label: t("general.comment"),
                    OnChange: (value_114) => {
                        props.Dispatch(new Msg(11, [procedureTemplateStepElement.Id, value_114]));
                    },
                    TestId: "tool-state-change-comment",
                    Value: currentComment_1,
                })) : empty(), delay(() => {
                    const matchValue_6 = FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id);
                    if (matchValue_6 == null) {
                        return empty();
                    }
                    else {
                        const msg_2 = matchValue_6;
                        return singleton(reactElement("p", {
                            className: join(" ", ["mt-1", "text-red", "text-sm"]),
                            children: msg_2,
                        }));
                    }
                })))))))))), ["children", reactApi.Children.toArray(Array.from(elems_11))])])));
            }
            case 20:
                return createElement(SendEmailNotice, {
                    Dispatch: unwrap(bind((result_2) => {
                        const matchValue_7 = result_2.Value;
                        if (matchValue_7.tag === 18) {
                            return matchValue_7.fields[0];
                        }
                        else {
                            return undefined;
                        }
                    }, tryFind((result_1) => (toString_1(result_1.ProcedureTemplateStepElementId) === procedureTemplateStepElement.Id), props.ExistingResults))),
                    EditableRecipients: unwrap(procedureTemplateStepElement.AllowRecipientEditing ? (new EditableEmailRecipients(defaultArg(map_1((_arg_23) => _arg_23.Recipients, tryFind((entry_2) => (entry_2.ProcedureTemplateStepElementId === procedureTemplateStepElement.Id), props.EditableEmailRecipients)), empty_1()), props.EmailRecipientUsers, bind((_arg_24) => _arg_24.EmailRecipients, currentResult), FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id), componentState, (recipients) => {
                        props.Dispatch(new Msg(16, [procedureTemplateStepElement.Id, recipients]));
                    })) : undefined),
                    Element: procedureTemplateStepElement,
                    IsTestMode: props.IsTestMode,
                });
            case 18: {
                const storageOptions = map((storage) => ({
                    label: Storage__get_DisplayName(storage),
                    value: unwrapStorageId(storage.Id),
                }), props.Storages);
                const currentStorageId = bind((_arg_25) => _arg_25.StorageTransferStorageId, currentResult);
                const currentStorageSpace = defaultArg(bind((_arg_26) => _arg_26.StorageTransferStorageSpace, currentResult), "");
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_12 = [reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: procedureTemplateStepElement.Label,
                }), createElement(Select, (Label_20 = t("tool.switch_storage_target"), (Value_11 = bind((storageId) => tryFind((o_1) => (o_1.value === storageId), storageOptions), currentStorageId), {
                    ComponentState: componentState,
                    IsClearable: true,
                    Label: unwrap(Label_20),
                    NoOptionsMessage: "",
                    OnChange: (option_46) => {
                        props.Dispatch(new Msg(12, [procedureTemplateStepElement.Id, map_1((o) => o.value, option_46)]));
                    },
                    Options: storageOptions,
                    PlaceholderKey: "",
                    TestId: "storage-transfer-target",
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id)),
                    Value: unwrap(Value_11),
                }))), createElement(Input, {
                    ComponentState: componentState,
                    Label: t("tool.storage_space"),
                    OnChange: (value_125) => {
                        props.Dispatch(new Msg(13, [procedureTemplateStepElement.Id, value_125]));
                    },
                    TestId: "storage-transfer-space",
                    Value: currentStorageSpace,
                })], ["children", reactApi.Children.toArray(Array.from(elems_12))])])));
            }
            case 19: {
                const entries = defaultArg(bind((_arg_27) => _arg_27.ReminderCompletionEntries, currentResult), empty_1());
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_15 = toList(delay(() => append(singleton(reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: procedureTemplateStepElement.Label,
                })), delay(() => (isEmpty(props.OpenReminders) ? singleton(reactElement("p", {
                    className: join(" ", ["text-sm", "text-gray-400"]),
                    children: t("procedure.reminder_completion.no_open_reminders"),
                })) : map((reminder) => {
                    let elems_14;
                    const entry_3 = tryFind((e_3) => (e_3.ReminderId === reminder.Id), entries);
                    const reminderDate = toString(toLocalTime(reminder.Date), "dd.MM.yyyy");
                    const updateEntry = (updatedEntry) => {
                        props.Dispatch(new Msg(14, [procedureTemplateStepElement.Id, updatedEntry]));
                    };
                    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_14 = toList(delay(() => append(singleton(Checkbox({
                        ComponentState: componentState,
                        IsChecked: entry_3 != null,
                        Label: concat(reminder.Title, " (", reminderDate, ...")"),
                        OnCheck: (value_136) => {
                            if (value_136) {
                                updateEntry(new ProcedureReminderCompletionEntry(reminder.Id, "", reminder.Interval != null, undefined, false, undefined));
                            }
                            else {
                                props.Dispatch(new Msg(15, [procedureTemplateStepElement.Id, reminder.Id]));
                            }
                        },
                        TestId: concat("procedure-reminder-", reminder.Title, ..."-checkbox"),
                    })), delay(() => {
                        let elems_13;
                        const matchValue_8 = entry_3;
                        if (matchValue_8 == null) {
                            return singleton(defaultOf());
                        }
                        else {
                            const entry_4 = matchValue_8;
                            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["ml-7", "flex", "flex-col", "gap-2"])], (elems_13 = toList(delay(() => append((reminder.Interval != null) ? append(singleton(Checkbox({
                                ComponentState: componentState,
                                IsChecked: entry_4.CreateNewDate,
                                Label: t("reminder_dialog.plan_next_date"),
                                OnCheck: (value_138) => {
                                    updateEntry(new ProcedureReminderCompletionEntry(entry_4.ReminderId, entry_4.Comment, value_138, entry_4.NextInspectionDate, entry_4.SetLastInspectionDate, entry_4.LastInspectionDate));
                                },
                                TestId: concat("procedure-reminder-", reminder.Title, ..."-plan-next-date-checkbox"),
                            })), delay(() => {
                                let Label_24, Value_12;
                                return entry_4.CreateNewDate ? singleton(createElement(DatePicker, (Label_24 = t("tool.next_inspection"), (Value_12 = map_1(parse, entry_4.NextInspectionDate), {
                                    ComponentState: componentState,
                                    IsClearable: true,
                                    Label: unwrap(Label_24),
                                    OnChange: (newDate) => {
                                        updateEntry(new ProcedureReminderCompletionEntry(entry_4.ReminderId, entry_4.Comment, entry_4.CreateNewDate, map_1(toISOString, newDate), entry_4.SetLastInspectionDate, entry_4.LastInspectionDate));
                                    },
                                    TestId: concat("procedure-reminder-", reminder.Title, ..."-next-inspection-date"),
                                    Value: unwrap(Value_12),
                                })))) : empty();
                            })) : empty(), delay(() => append(singleton(Checkbox({
                                ComponentState: componentState,
                                IsChecked: entry_4.SetLastInspectionDate,
                                Label: t("reminder_dialog.set_last_check_field"),
                                OnCheck: (value_139) => {
                                    updateEntry(new ProcedureReminderCompletionEntry(entry_4.ReminderId, entry_4.Comment, entry_4.CreateNewDate, entry_4.NextInspectionDate, value_139, entry_4.LastInspectionDate));
                                },
                                TestId: concat("procedure-reminder-", reminder.Title, ..."-set-last-check-field-checkbox"),
                            })), delay(() => append(entry_4.SetLastInspectionDate ? singleton(createElement(DatePicker, {
                                ComponentState: componentState,
                                IsClearable: true,
                                Label: t("reminder_dialog.check_date"),
                                OnChange: (newDate_1) => {
                                    updateEntry(new ProcedureReminderCompletionEntry(entry_4.ReminderId, entry_4.Comment, entry_4.CreateNewDate, entry_4.NextInspectionDate, entry_4.SetLastInspectionDate, newDate_1));
                                },
                                TestId: concat("procedure-reminder-", reminder.Title, ..."-check-date"),
                                Value: unwrap(entry_4.LastInspectionDate),
                            })) : empty(), delay(() => singleton(createElement(TextArea, {
                                ComponentState: componentState,
                                Label: t("general.comment"),
                                OnChange: (value_140) => {
                                    updateEntry(new ProcedureReminderCompletionEntry(entry_4.ReminderId, value_140, entry_4.CreateNewDate, entry_4.NextInspectionDate, entry_4.SetLastInspectionDate, entry_4.LastInspectionDate));
                                },
                                TestId: concat("procedure-reminder-", reminder.Title, ..."-comment-textarea"),
                                Value: entry_4.Comment,
                            })))))))))), ["children", reactApi.Children.toArray(Array.from(elems_13))])]))));
                        }
                    })))), ["children", reactApi.Children.toArray(Array.from(elems_14))])])));
                }, props.OpenReminders)))))), ["children", reactApi.Children.toArray(Array.from(elems_15))])])));
            }
            case 15: {
                const elementDocuments_1 = defaultArg(map_1((_arg_28) => _arg_28.Files, tryFind((entry_5) => (entry_5.ElementId === procedureTemplateStepElement.Id), props.DocumentUploads)), empty_1());
                const fileUploadId_1 = concat("doc-upload-", ...procedureTemplateStepElement.Id);
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems_21 = toList(delay(() => append(singleton(reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: procedureTemplateStepElement.Label,
                })), delay(() => {
                    let elems_16;
                    return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "justify-center", "items-center", "rounded-lg", "border", "border-dashed", "border-primary", "p-4"])], ["onDragOver", (e_4) => {
                        e_4.preventDefault();
                    }], ["onDrop", (e_5) => {
                        e_5.preventDefault();
                        if (!props.FormState.IsLoading) {
                            props.Dispatch(new Msg(22, [procedureTemplateStepElement.Id, toList(delay(() => map_2((i_2) => e_5.dataTransfer.files.item(i_2), rangeDouble(0, 1, e_5.dataTransfer.files.length - 1))))]));
                        }
                    }], (elems_16 = [createElement(TextButton, {
                        ComponentState: componentState,
                        Label: t("file_upload.select_file"),
                        OnClick: () => {
                            const element_1 = document.getElementById(fileUploadId_1);
                            element_1.click();
                        },
                        TestId: concat("procedure-select-file-", procedureTemplateStepElement.Label, ..."-button"),
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_16))])])))), delay(() => append(singleton(reactElement("input", {
                        id: fileUploadId_1,
                        className: join(" ", ["hidden"]),
                        type: "file",
                        multiple: true,
                        disabled: props.FormState.IsLoading,
                        onChange: (ev_1) => {
                            const fileList_1 = ev_1.target.files;
                            if (!(fileList_1 == null)) {
                                props.Dispatch(new Msg(22, [procedureTemplateStepElement.Id, toList(delay(() => map_2((i_3) => fileList_1.item(i_3), rangeDouble(0, 1, fileList_1.length - 1))))]));
                            }
                        },
                    })), delay(() => {
                        let elems_20;
                        return append(!isEmpty(elementDocuments_1) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3", "mt-2"])], (elems_20 = toList(delay(() => map((tupledArg_2) => {
                            let elems_19, elems_17, elems_18;
                            const index_2 = tupledArg_2[0] | 0;
                            const docFile_1 = tupledArg_2[1];
                            return reactElement("div", createObj(ofArray([["className", join(" ", ["rounded-md", "border", "border-border", "p-3"])], (elems_19 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-between", "mb-2"])], (elems_17 = [reactElement("span", {
                                className: join(" ", ["text-sm", "truncate", "font-medium"]),
                                children: docFile_1.File.name,
                            }), reactElement("button", {
                                className: join(" ", ["text-gray-400", "hover:text-red", "cursor-pointer", "ml-2", "flex-shrink-0", "disabled:opacity-50", "disabled:cursor-not-allowed"]),
                                type: "button",
                                disabled: props.FormState.IsLoading,
                                onClick: (e_6) => {
                                    e_6.preventDefault();
                                    e_6.stopPropagation();
                                    props.Dispatch(new Msg(23, [procedureTemplateStepElement.Id, index_2]));
                                },
                                children: "✕",
                            })], ["children", reactApi.Children.toArray(Array.from(elems_17))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-2"])], (elems_18 = [createElement(Input, {
                                ComponentState: componentState,
                                Label: t("general.name"),
                                OnChange: (v_5) => {
                                    props.Dispatch(new Msg(24, [procedureTemplateStepElement.Id, index_2, v_5]));
                                },
                                TestId: `document-name-input-${procedureTemplateStepElement.Label}-${index_2}`,
                                Value: docFile_1.Name,
                            }), createElement(Input, {
                                ComponentState: componentState,
                                Label: t("general.description"),
                                OnChange: (v_6) => {
                                    props.Dispatch(new Msg(25, [procedureTemplateStepElement.Id, index_2, v_6]));
                                },
                                TestId: `document-description-input-${procedureTemplateStepElement.Label}-${index_2}`,
                                Value: docFile_1.Description,
                            }), Checkbox({
                                ComponentState: componentState,
                                IsChecked: docFile_1.IsVisibleForUserRole,
                                Label: t("tool.document_visible_for_user_role"),
                                OnCheck: (_arg_30) => {
                                    props.Dispatch(new Msg(26, [procedureTemplateStepElement.Id, index_2]));
                                },
                                TestId: `document-visible-for-user-checkbox-${procedureTemplateStepElement.Label}-${index_2}`,
                            })], ["children", reactApi.Children.toArray(Array.from(elems_18))])])))], ["children", reactApi.Children.toArray(Array.from(elems_19))])])));
                        }, indexed(elementDocuments_1)))), ["children", reactApi.Children.toArray(Array.from(elems_20))])])))) : empty(), delay(() => {
                            const matchValue_9 = FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id);
                            if (matchValue_9 == null) {
                                return empty();
                            }
                            else {
                                const msg_3 = matchValue_9;
                                return singleton(reactElement("p", {
                                    className: join(" ", ["mt-1", "text-red", "text-sm"]),
                                    children: msg_3,
                                }));
                            }
                        }));
                    }))));
                })))), ["children", reactApi.Children.toArray(Array.from(elems_21))])])));
            }
            default:
                return createElement(Input, (Value = defaultArg(bind((_arg) => _arg.TextValue, currentResult), ""), {
                    ComponentState: componentState,
                    Label: procedureTemplateStepElement.Label,
                    OnChange: (value_4) => {
                        props.Dispatch(new Msg(0, [procedureTemplateStepElement.Id, value_4]));
                    },
                    TestId: concat("procedure-element-", ...procedureTemplateStepElement.Label),
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, procedureTemplateStepElement.Id)),
                    Value: Value,
                }));
        }
    }, props.ProcedureTemplateStep.Elements))), ["children", reactApi.Children.toArray(Array.from(elems_22))])])))], ["children", reactApi.Children.toArray(Array.from(elems_23))])]))), StepFooter(ofArray([createElement(Button, {
        ComponentState: componentState,
        Label: t("general.back"),
        OnClick: () => {
            props.Dispatch(new Msg(32, [undefined]));
        },
        TestId: "procedure-step-back",
        Variant: "secondary",
    }), createElement(Button, {
        ComponentState: componentState,
        Label: t("general.save"),
        OnClick: () => {
            props.Dispatch(new Msg(38, []));
        },
        TestId: "procedure-step-save",
        Variant: "primary",
    })]))], ["children", reactApi.Children.toArray(Array.from(elems_24))])])));
}

function resultRow(label, testId, content) {
    let elems_1;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-1", "sm:grid-cols-[2fr_3fr]", "gap-x-6", "gap-y-1", "py-3.5", "border-b", "border-divider", "text-sm"])], ["data-test-id", testId], (elems_1 = [reactElement("div", {
        className: join(" ", ["font-semibold", "break-words"]),
        children: label,
    }), reactElement("div", {
        className: join(" ", ["flex", "flex-col", "gap-1", "min-w-0", "break-words"]),
        children: reactApi.Children.toArray(Array.from(content)),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function resultInfoText(testId, text) {
    return reactElement("p", {
        className: join(" ", ["py-3.5", "border-b", "border-divider", "text-sm", "whitespace-pre-wrap", "break-words"]),
        "data-test-id": testId,
        children: text,
    });
}

function mutedText(text) {
    return reactElement("span", {
        className: join(" ", ["text-text-muted"]),
        children: text,
    });
}

function ProcedureStepDetails(props) {
    let elems_4, elems_3, elems_2;
    const t = useTranslation()[0];
    const inventoryStates = useDefinitions();
    let currency;
    const matchValue = props.CustomerConfiguration;
    currency = ((matchValue.tag === 1) ? matchValue.fields[0].Currency : "eUR");
    const findResult = (element) => tryFind((result) => (toString_1(result.ProcedureTemplateStepElementId) === element.Id), props.ProcedureStep.Results);
    const resultText = (element_1) => defaultArg(filter_1((value) => (value !== ""), map_1((_arg) => ProcedureStepElementResultValue__ResultToString(_arg.Value), findResult(element_1))), "-");
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "grow"])], (elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-6", "w-full", "max-w-[51rem]", "px-4", "py-6"])], (elems_3 = [createElement(StepHeader, {
        Description: props.ProcedureTemplateStep.Description,
        Name: props.ProcedureTemplateStep.Name,
        StepCount: props.StepCount,
        StepNumber: props.StepNumber,
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "border-t", "border-divider"])], (elems_2 = map((element_2) => {
        let matchValue_4, matchValue_5, matchValue_6, propertyConfigurationId, value_23, value_24, elems_1, matchValue_11, ids;
        const testId = concat("procedure-element-", ...element_2.Label);
        const matchValue_1 = element_2.Type;
        switch (matchValue_1.tag) {
            case 1:
                return resultRow(element_2.Label, testId, singleton_1(reactElement("span", {
                    className: join(" ", ["whitespace-pre-line"]),
                    children: resultText(element_2),
                })));
            case 2:
            case 7:
            case 12:
                return resultInfoText(testId, element_2.Label);
            case 8: {
                const hasSignature = exists_1((result_1) => {
                    if (result_1.Value.tag === 6) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }, toArray(findResult(element_2)));
                return resultRow(element_2.Label, testId, toList(delay(() => (hasSignature ? singleton(reactElement("span", {
                    className: join(" ", ["font-semibold", "text-primary-link"]),
                    children: t("procedure.signature_provided"),
                })) : singleton(mutedText(t("procedure.no_signature")))))));
            }
            case 5:
                return resultRow(element_2.Label, testId, singleton_1(reactElement("span", {
                    children: defaultArg(map_1((result_2) => {
                        const matchValue_3 = result_2.Value;
                        if (matchValue_3.tag === 3) {
                            if (matchValue_3.fields[0]) {
                                return t("general.yes");
                            }
                            else {
                                return t("general.no");
                            }
                        }
                        else {
                            return "-";
                        }
                    }, findResult(element_2)), "-"),
                })));
            case 13: {
                const photoUrls = defaultArg(map_1((_arg_1) => _arg_1.DocumentUrls, findResult(element_2)), empty_1());
                return resultRow(element_2.Label, testId, toList(delay(() => {
                    let elems;
                    return isEmpty(photoUrls) ? singleton(mutedText("-")) : singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-2"])], (elems = toList(delay(() => map_2((url) => reactElement("img", {
                        className: join(" ", ["rounded-lg", "border", "border-divider", "h-24", "w-24", "object-cover"]),
                        src: url,
                    }), photoUrls))), ["children", reactApi.Children.toArray(Array.from(elems))])]))));
                })));
            }
            case 14: {
                const inspectionComment = defaultArg(bind((_arg_2) => _arg_2.Comment, findResult(element_2)), "");
                return resultRow((matchValue_4 = element_2.InspectionTemplateName, (matchValue_4 == null) ? element_2.Label : concat(element_2.Label, " (", matchValue_4, ...")")), testId, toList(delay(() => append(singleton(reactElement("span", {
                    className: join(" ", ["font-semibold"]),
                    children: resultText(element_2),
                })), delay(() => ((inspectionComment !== "") ? singleton(mutedText(inspectionComment)) : empty()))))));
            }
            case 16:
                return resultRow(element_2.Label, testId, singleton_1(reactElement("span", {
                    children: (matchValue_5 = map_1((_arg_3) => _arg_3.Value, findResult(element_2)), (matchValue_6 = element_2.PropertyConfigurationId, (matchValue_5 == null) ? "-" : ((matchValue_5.tag === 14) ? ((matchValue_6 != null) ? ((propertyConfigurationId = matchValue_6, (value_23 = matchValue_5.fields[0], Helper_resolveDisplayValue(currency, props.PropertyConfigurations, propertyConfigurationId, value_23)))) : ((value_24 = matchValue_5, ProcedureStepElementResultValue__ResultToString(value_24)))) : ((value_24 = matchValue_5, ProcedureStepElementResultValue__ResultToString(value_24)))))),
                })));
            case 15:
                return resultRow(element_2.Label, testId, singleton_1(mutedText(`${defaultArg(map_1((_arg_4) => (length(_arg_4.DocumentUrls) | 0), findResult(element_2)), 0)} ${t("procedure.document_count")}`)));
            case 17: {
                const resultData = findResult(element_2);
                let displayText;
                const matchValue_8 = map_1((_arg_5) => _arg_5.Value, resultData);
                let matchResult, state;
                if (matchValue_8 != null) {
                    if (matchValue_8.tag === 15) {
                        if (matchValue_8.fields[0] == null) {
                            matchResult = 1;
                        }
                        else {
                            matchResult = 0;
                            state = matchValue_8.fields[0];
                        }
                    }
                    else {
                        matchResult = 2;
                    }
                }
                else {
                    matchResult = 2;
                }
                switch (matchResult) {
                    case 0: {
                        displayText = nameOfKey(t, inventoryStates, state);
                        break;
                    }
                    case 1: {
                        displayText = t("procedure.tool_state_change.no_change");
                        break;
                    }
                    default:
                        displayText = "-";
                }
                const displayComment = defaultArg(bind((_arg_6) => _arg_6.Comment, resultData), "");
                return resultRow(element_2.Label, testId, toList(delay(() => append(singleton(reactElement("span", {
                    children: displayText,
                })), delay(() => ((displayComment !== "") ? singleton(mutedText(displayComment)) : empty()))))));
            }
            case 20: {
                const dispatch_1 = bind((result_3) => {
                    const matchValue_9 = result_3.Value;
                    if (matchValue_9.tag === 18) {
                        return matchValue_9.fields[0];
                    }
                    else {
                        return undefined;
                    }
                }, findResult(element_2));
                return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1.5", "py-3.5", "border-b", "border-divider"])], ["data-test-id", testId], (elems_1 = [reactElement("span", {
                    className: join(" ", ["text-sm", "font-semibold"]),
                    children: element_2.Label,
                }), createElement(SendEmailDispatch, {
                    Dispatch: unwrap(dispatch_1),
                    Element: element_2,
                    IsTestMode: props.IsTestMode,
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
            }
            case 18: {
                let transferResult;
                const matchValue_10 = map_1((_arg_7) => _arg_7.Value, findResult(element_2));
                let matchResult_1, value_38;
                if (matchValue_10 != null) {
                    if (matchValue_10.tag === 16) {
                        matchResult_1 = 0;
                        value_38 = matchValue_10.fields[0];
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
                switch (matchResult_1) {
                    case 0: {
                        transferResult = value_38;
                        break;
                    }
                    default:
                        transferResult = undefined;
                }
                return resultRow(element_2.Label, testId, toList(delay(() => {
                    if (transferResult == null) {
                        return singleton(reactElement("span", {
                            children: "-",
                        }));
                    }
                    else {
                        const result_4 = transferResult;
                        return append(singleton(reactElement("span", {
                            children: defaultArg(map_1(Storage__get_DisplayName, tryFind((storage) => (unwrapStorageId(storage.Id) === result_4.StorageId), props.Storages)), result_4.StorageId),
                        })), delay(() => ((result_4.StorageSpace !== "") ? singleton(mutedText(result_4.StorageSpace)) : empty())));
                    }
                })));
            }
            case 19:
                return resultRow(element_2.Label, testId, singleton_1(reactElement("span", {
                    children: `${(matchValue_11 = map_1((_arg_9) => _arg_9.Value, findResult(element_2)), (matchValue_11 != null) ? ((matchValue_11.tag === 17) ? ((ids = matchValue_11.fields[0], length(ids))) : 0) : 0)} ${t("procedure.reminder_completion.completed_label")}`,
                })));
            default:
                return resultRow(element_2.Label, testId, singleton_1(reactElement("span", {
                    children: resultText(element_2),
                })));
        }
    }, props.ProcedureTemplateStep.Elements), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), StepFooter(singleton_1(createElement(Button, {
        ComponentState: "enabled",
        Label: t("general.back"),
        OnClick: () => {
            props.Dispatch(new Msg(32, [undefined]));
        },
        TestId: "procedure-step-back",
        Variant: "secondary",
    })))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

export function ProcedureStepOverview(props) {
    let elems_3, elems_1, elems_2;
    const patternInput = useTranslation();
    return reactElement("button", createObj(ofArray([["type", "button"], ["data-test-id", concat("procedure-step-", ...props.ProcedureTemplateStep.Name)], ["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("items-center"), delay(() => append(singleton("gap-3"), delay(() => append(singleton("w-full"), delay(() => append(singleton("p-[15px]"), delay(() => append(singleton("text-left"), delay(() => append(singleton("rounded-[10px]"), delay(() => append(singleton("bg-background"), delay(() => append(singleton("hover:bg-divider"), delay(() => append(singleton("cursor-pointer"), delay(() => (props.HasValidationError ? append(singleton("border"), delay(() => singleton("border-red"))) : empty()))))))))))))))))))))))))], ["onClick", (e) => {
        e.preventDefault();
        props.Dispatch(new Msg(32, [new ProcedureTemplateStepId(parse_1(props.ProcedureTemplateStep.Id))]));
    }], (elems_3 = [reactElement("span", createObj(toList(delay(() => append(singleton(["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("items-center"), delay(() => append(singleton("justify-center"), delay(() => append(singleton("w-9"), delay(() => append(singleton("h-9"), delay(() => append(singleton("shrink-0"), delay(() => append(singleton("rounded-full"), delay(() => append(singleton("text-sm"), delay(() => append(singleton("font-bold"), delay(() => (props.IsCompleted ? singleton("bg-primary") : singleton("bg-divider")))))))))))))))))))))))]), delay(() => (props.IsCompleted ? append(singleton(["aria-label", patternInput[0]("procedure.step_completed")]), delay(() => append(singleton(["data-test-id", "procedure-step-completed"]), delay(() => {
        let elems;
        return singleton((elems = [IconCheckmark(20)], ["children", reactApi.Children.toArray(Array.from(elems))]));
    })))) : singleton(["children", int32ToString(props.StepNumber)])))))))), reactElement("span", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "grow", "min-w-0"])], (elems_1 = toList(delay(() => append(singleton(reactElement("span", {
        className: join(" ", ["text-base", "font-semibold", "break-words"]),
        children: props.ProcedureTemplateStep.Name,
    })), delay(() => ((props.ProcedureTemplateStep.Description !== "") ? singleton(reactElement("span", {
        className: join(" ", ["mt-1", "text-[13px]", "text-text-muted", "line-clamp-2", "break-words"]),
        children: props.ProcedureTemplateStep.Description,
    })) : empty()))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("span", createObj(ofArray([["className", join(" ", ["shrink-0", "text-text-muted"])], (elems_2 = [IconChevronRight(24)], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function formatDateTime(value) {
    return toString(toLocalTime(value), "dd.MM.yyyy, HH:mm");
}

function ProcedureResultMeta(props) {
    let elems;
    const i18n = useTranslation()[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-x-6", "gap-y-1", "text-[13px]", "text-text-muted"])], ["data-test-id", "procedure-result-meta"], (elems = toList(delay(() => {
        let matchValue, arg_1;
        return append((matchValue = props.PerformedBy, (matchValue == null) ? (empty()) : singleton(reactElement("span", {
            children: (arg_1 = {
                name: matchValue,
            }, i18n.t("procedure.result_meta.performed_by", arg_1)),
        }))), delay(() => {
            let arg_3;
            return append(singleton(reactElement("span", {
                children: (arg_3 = {
                    date: formatDateTime(props.Procedure.StartDate),
                }, i18n.t("procedure.result_meta.started", arg_3)),
            })), delay(() => {
                let arg_5;
                const matchValue_1 = props.Procedure.EndDate;
                if (matchValue_1 == null) {
                    return empty();
                }
                else {
                    return singleton(reactElement("span", {
                        children: (arg_5 = {
                            date: formatDateTime(matchValue_1),
                        }, i18n.t("procedure.result_meta.completed", arg_5)),
                    }));
                }
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function ProcedureForm(props) {
    let elems_14;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsCancelConfirmationOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsCompleteConfirmationOpen = patternInput_2[1];
    const dependencies = [props.SelectedTemplateStep];
    reactApi.useEffect(() => {
        setIsCompleteConfirmationOpen(false);
    }, dependencies);
    const procedureState = props.ProcedureForm.Procedure.State;
    const isReadOnly = (procedureState.tag === 1) ? true : ((procedureState.tag === 2) ? true : (procedureState.tag === 3));
    const templateSteps = props.ProcedureForm.ProcedureTemplate.Steps;
    const stepCount = length(templateSteps) | 0;
    const completedTemplateStepIds = ofList_1(map((step) => toString_1(step.ProcedureTemplateStepId), props.ProcedureForm.Procedure.Steps), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    const completedStepCount = length(filter((step_1) => contains_1(step_1.Id, completedTemplateStepIds), templateSteps)) | 0;
    let stepsProgressText;
    const arg_1 = {
        completed: completedStepCount,
        total: stepCount,
    };
    stepsProgressText = (patternInput[1].t("procedure.steps_progress", arg_1));
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "grow", "bg-white", "overflow-y-auto"])], (elems_14 = toList(delay(() => {
        let elems_7;
        const matchValue = props.SelectedTemplateStep;
        if (matchValue == null) {
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3", "w-full", "max-w-[51rem]", "px-4", "py-6"])], (elems_7 = toList(delay(() => append((props.ProcedureForm.ProcedureTemplate.Description !== "") ? singleton(reactElement("p", {
                className: join(" ", ["text-sm", "whitespace-pre-wrap", "break-words"]),
                children: props.ProcedureForm.ProcedureTemplate.Description,
            })) : empty(), delay(() => {
                let matchValue_2;
                return append((matchValue_2 = procedureState, (matchValue_2.tag === 2) ? singleton(createElement(WarningAlert, {
                    Label: t("procedure.status_completed_failed"),
                })) : ((matchValue_2.tag === 3) ? singleton(createElement(InformationAlert, {
                    Label: t("procedure.status_cancelled"),
                })) : ((matchValue_2.tag === 0) ? (empty()) : singleton(createElement(SuccessAlert, {
                    Label: t("procedure.status_completed_successful"),
                }))))), delay(() => append((isReadOnly && !props.IsTestMode) ? singleton(createElement(ProcedureResultMeta, {
                    PerformedBy: unwrap(props.ProcedureForm.PerformedBy),
                    Procedure: props.ProcedureForm.Procedure,
                })) : empty(), delay(() => {
                    let matchValue_3, entity, entityTypeKey, matchValue_4, elems_1;
                    return append((matchValue_3 = props.ProcedureForm.Entity, (matchValue_3 == null) ? (empty()) : ((entity = matchValue_3, (entityTypeKey = ((matchValue_4 = entity.Reference, (matchValue_4.tag === 1) ? "procedure.entity.type_tool_with_quantity" : ((matchValue_4.tag === 2) ? "procedure.entity.type_consumable" : ((matchValue_4.tag === 3) ? "procedure.entity.type_set" : "procedure.entity.type_tool")))), singleton(reactElement("section", createObj(ofArray([["className", join(" ", ["rounded-lg", "border", "border-divider", "p-3"])], ["data-test-id", "procedure-entity-card"], (elems_1 = toList(delay(() => append(singleton(reactElement("div", {
                        className: join(" ", ["text-[13px]", "text-text-muted"]),
                        children: t(entityTypeKey),
                    })), delay(() => append(singleton(reactElement("div", {
                        className: join(" ", ["mt-0.5", "text-[15px]", "font-bold", "break-words"]),
                        children: entity.DisplayName,
                    })), delay(() => {
                        let matchValue_5, quantity, unit;
                        return append((matchValue_5 = entity.Quantity, (matchValue_5 == null) ? (empty()) : ((quantity = matchValue_5, (unit = defaultArg(map_1((unitKey) => concat(" ", ...t(unitKey)), entity.Unit), ""), singleton(reactElement("div", {
                            className: join(" ", ["text-[13px]", "mt-1"]),
                            children: `${t("procedure.entity.quantity")}: ${quantity}${unit}`,
                        })))))), delay(() => (!isEmpty(entity.SetItems) ? append(singleton(reactElement("div", {
                            className: join(" ", ["text-[13px]", "text-text-muted", "mt-3"]),
                            children: t("procedure.entity.set_items"),
                        })), delay(() => {
                            let elems;
                            return singleton(reactElement("ul", createObj(ofArray([["className", join(" ", ["text-[13px]", "list-disc", "ml-5"])], (elems = toList(delay(() => map_2((item) => reactElement("li", {
                                children: item.DisplayName,
                            }), entity.SetItems))), ["children", reactApi.Children.toArray(Array.from(elems))])]))));
                        })) : empty())));
                    })))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))))))), delay(() => {
                        let elems_3, elems_2;
                        return append(!isEmpty(props.ProcedureForm.InformationFieldValues) ? singleton(reactElement("section", createObj(ofArray([["className", join(" ", ["rounded-lg", "border", "border-divider", "p-3"])], (elems_3 = [reactElement("h3", {
                            className: join(" ", ["mb-2", "text-sm", "font-bold"]),
                            children: t("procedure.information_fields.title"),
                        }), reactElement("dl", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-[2fr_3fr]", "gap-x-2", "gap-y-1", "text-[13px]"])], (elems_2 = toList(delay(() => collect((fieldValue) => append(singleton(reactElement("dt", {
                            className: join(" ", ["text-text-muted", "break-words"]),
                            children: t(fieldValue.Label),
                        })), delay(() => singleton(reactElement("dd", {
                            className: join(" ", ["break-words"]),
                            "data-test-id": concat("procedure-information-field-", ...fieldValue.Label),
                            children: (fieldValue.Value !== "") ? fieldValue.Value : "-",
                        })))), props.ProcedureForm.InformationFieldValues))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))) : empty(), delay(() => {
                            let elems_5, elems_4;
                            return append(!isReadOnly ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-3", "mt-2"])], (elems_5 = [reactElement("span", {
                                className: join(" ", ["text-[13px]", "font-semibold", "whitespace-nowrap"]),
                                "data-test-id": "procedure-steps-progress",
                                children: stepsProgressText,
                            }), reactElement("div", createObj(ofArray([["className", join(" ", ["grow", "h-1.5", "rounded-full", "bg-divider", "overflow-hidden"])], ["role", join(" ", ["progressbar"])], ["aria-valuemin", 0], ["aria-valuemax", stepCount], ["aria-valuenow", completedStepCount], (elems_4 = [reactElement("div", {
                                className: join(" ", ["h-1.5", "rounded-full", "bg-primary"]),
                                style: {
                                    width: ((stepCount === 0) ? 0 : ((completedStepCount / stepCount) * 100)) + "%",
                                },
                            })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))) : empty(), delay(() => {
                                let elems_6;
                                return singleton(reactElement("nav", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("flex-col"), delay(() => append(singleton("gap-2"), delay(() => (isReadOnly ? singleton("mt-2") : empty()))))))))))], ["aria-label", t("procedure.steps")], (elems_6 = toList(delay(() => mapIndexed((index, step_4) => {
                                    let StepNumber_2, IsCompleted;
                                    return createElement(ProcedureStepOverview, (StepNumber_2 = ((index + 1) | 0), (IsCompleted = contains_1(step_4.Id, completedTemplateStepIds), {
                                        Dispatch: props.Dispatch,
                                        HasValidationError: containsKey(step_4.Id, props.FormState.Validations),
                                        IsCompleted: IsCompleted,
                                        ProcedureTemplateStep: step_4,
                                        StepNumber: StepNumber_2,
                                    })));
                                }, templateSteps))), ["children", reactApi.Children.toArray(Array.from(elems_6))])]))));
                            }));
                        }));
                    }));
                }))));
            })))), ["children", reactApi.Children.toArray(Array.from(elems_7))])])))), delay(() => {
                let elems_13;
                return !isReadOnly ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["sticky", "bottom-0", "mt-auto", "bg-white", "px-4", "pt-3", "pb-4"])], (elems_13 = toList(delay(() => {
                    let elems_11, elems_9, elems_8, elems_10, elems_12;
                    return append(patternInput_2[0] ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3", "max-w-[49rem]", "text-sm"])], ["data-test-id", "complete-procedure-confirmation"], (elems_11 = [reactElement("p", {
                        className: join(" ", ["text-base", "font-bold"]),
                        children: t("procedure.complete_confirmation_title"),
                    }), reactElement("p", {
                        children: t("procedure.complete_confirmation"),
                    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2.5"])], ["data-test-id", "complete-procedure-summary"], (elems_9 = [reactElement("span", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("h-5"), delay(() => append(singleton("w-5"), delay(() => ((completedStepCount === stepCount) ? singleton("text-icon-green") : singleton("text-icon-orange")))))))))], (elems_8 = [Check_Circle()], ["children", reactApi.Children.toArray(Array.from(elems_8))])]))), reactElement("span", {
                        children: stepsProgressText,
                    })], ["children", reactApi.Children.toArray(Array.from(elems_9))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "justify-end", "gap-5"])], (elems_10 = [createElement(BaseButton, {
                        Classes: empty_1(),
                        ComponentState: componentState,
                        Label: t("general.cancel"),
                        Level: "secondary",
                        OnClick: () => {
                            setIsCompleteConfirmationOpen(false);
                        },
                        TestId: "complete-procedure-cancel",
                    }), createElement(BaseButton, {
                        Classes: empty_1(),
                        ComponentState: componentState,
                        Label: t("procedure.complete_confirmation_confirm"),
                        Level: "primary",
                        OnClick: () => {
                            setIsCompleteConfirmationOpen(false);
                            props.Dispatch(new Msg(50, []));
                        },
                        TestId: "complete-procedure-confirm",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_10))])])))], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))) : singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "justify-end", "gap-5", "max-w-[49rem]"])], (elems_12 = [createElement(BaseButton, {
                        Classes: empty_1(),
                        ComponentState: componentState,
                        Label: t("procedure.cancel_procedure"),
                        Level: "secondary",
                        OnClick: () => {
                            setIsCancelConfirmationOpen(true);
                        },
                        TestId: "cancel-procedure",
                    }), createElement(BaseButton, {
                        Classes: empty_1(),
                        ComponentState: componentState,
                        Label: t("procedure.complete_procedure"),
                        Level: "primary",
                        OnClick: () => {
                            setIsCompleteConfirmationOpen(true);
                        },
                        TestId: "complete-procedure",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_12))])])))), delay(() => {
                        let Title;
                        return singleton(createElement(ConfirmationDialogWithClasses, (Title = t("procedure.cancel_procedure"), {
                            Classes: singleton_1("z-[1100]"),
                            Description: t("procedure.cancel_confirmation"),
                            FormState: props.FormState,
                            IsOpen: patternInput_1[0],
                            OnClose: () => {
                                setIsCancelConfirmationOpen(false);
                            },
                            OnConfirm: () => {
                                setIsCancelConfirmationOpen(false);
                                props.Dispatch(new Msg(52, []));
                            },
                            Title: Title,
                        })));
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_13))])])))) : empty();
            }));
        }
        else {
            const templateStepId = matchValue;
            const stepIndex = findIndex((step_2) => equals(new ProcedureTemplateStepId(parse_1(step_2.Id)), templateStepId), templateSteps) | 0;
            const procedureTemplateStep = item_1(stepIndex, templateSteps);
            const existingProcedureStep = tryFind((step_3) => equals(step_3.ProcedureTemplateStepId, new ProcedureTemplateStepId(parse_1(procedureTemplateStep.Id))), props.ProcedureForm.Procedure.Steps);
            let matchResult, procedureStep;
            if (existingProcedureStep != null) {
                if (isReadOnly) {
                    matchResult = 0;
                    procedureStep = existingProcedureStep;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return singleton(createElement(ProcedureStepDetails, {
                        CustomerConfiguration: props.CustomerConfiguration,
                        Dispatch: props.Dispatch,
                        IsTestMode: props.IsTestMode,
                        ProcedureStep: procedureStep,
                        ProcedureTemplateStep: procedureTemplateStep,
                        PropertyConfigurations: props.PropertyConfigurations,
                        StepCount: stepCount,
                        StepNumber: stepIndex + 1,
                        Storages: props.Storages,
                    }));
                default:
                    return singleton(createElement(ProcedureStepForm, {
                        CurrentToolStateKey: unwrap(props.ProcedureForm.CurrentToolStateKey),
                        CustomerConfiguration: props.CustomerConfiguration,
                        Dispatch: props.Dispatch,
                        DocumentUploads: props.DocumentUploads,
                        EditableEmailRecipients: props.ProcedureForm.EditableEmailRecipients,
                        EmailRecipientUsers: props.ProcedureForm.EmailRecipientUsers,
                        ExistingResults: defaultArg(map_1((_arg) => _arg.Results, existingProcedureStep), empty_1()),
                        FormState: props.FormState,
                        InspectionDocuments: props.InspectionDocuments,
                        IsTestMode: props.IsTestMode,
                        OpenReminders: props.ProcedureForm.OpenReminders,
                        PhotoUploads: props.PhotoUploads,
                        ProcedureTemplateStep: procedureTemplateStep,
                        PropertyConfigurations: props.PropertyConfigurations,
                        StepCount: stepCount,
                        StepFiles: props.StepFiles,
                        StepNumber: stepIndex + 1,
                        Storages: props.Storages,
                        WriteProcedureStepDto: props.WriteProcedureStepDto,
                    }));
            }
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_14))])])));
}

export function View(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), props.ProcedureId, undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.ProcedureForm;
    if (matchValue.tag === 0) {
        return createElement(Skeleton, {
            Variant: "normal",
        });
    }
    else {
        return createElement(ProcedureForm, {
            CustomerConfiguration: state_1.CustomerConfiguration,
            Dispatch: patternInput[1],
            DocumentUploads: state_1.DocumentUploads,
            FormState: state_1.FormState,
            InspectionDocuments: state_1.InspectionDocuments,
            IsTestMode: false,
            PhotoUploads: state_1.PhotoUploads,
            ProcedureForm: matchValue.fields[0],
            PropertyConfigurations: state_1.PropertyConfigurations,
            SelectedTemplateStep: unwrap(state_1.SelectedTemplateStep),
            StepFiles: state_1.StepFiles,
            Storages: state_1.Storages,
            WriteProcedureStepDto: state_1.WriteProcedureStepDto,
        });
    }
}

export function OpenProcedureModal(props) {
    let elems, matchValue, matchValue_1;
    const patternInput = useTranslation();
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), props.ProcedureId, undefined);
    const state_1 = patternInput_1[0];
    const dependencies_1 = [state_1.IsProcedureCompleted];
    reactApi.useEffect(() => {
        if (state_1.IsProcedureCompleted) {
            props.OnSuccessCallback();
        }
    }, dependencies_1);
    const dependencies_3 = [state_1.IsProcedureCancelled];
    reactApi.useEffect(() => {
        if (state_1.IsProcedureCancelled) {
            props.OnCancelCallback();
        }
    }, dependencies_3);
    return reactElement("div", createObj(singleton_1((elems = [createElement(ModalSheet, {
        CloseButtonTestId: "procedure-modal-close",
        Content: (matchValue = state_1.ProcedureForm, (matchValue.tag === 0) ? createElement(Skeleton, {
            Variant: "normal",
        }) : createElement(ProcedureForm, {
            CustomerConfiguration: state_1.CustomerConfiguration,
            Dispatch: patternInput_1[1],
            DocumentUploads: state_1.DocumentUploads,
            FormState: state_1.FormState,
            InspectionDocuments: state_1.InspectionDocuments,
            IsTestMode: false,
            PhotoUploads: state_1.PhotoUploads,
            ProcedureForm: matchValue.fields[0],
            PropertyConfigurations: state_1.PropertyConfigurations,
            SelectedTemplateStep: unwrap(state_1.SelectedTemplateStep),
            StepFiles: state_1.StepFiles,
            Storages: state_1.Storages,
            WriteProcedureStepDto: state_1.WriteProcedureStepDto,
        })),
        Controls: empty_1(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: unwrap((matchValue_1 = state_1.ProcedureForm, (matchValue_1.tag === 0) ? undefined : matchValue_1.fields[0].Procedure.Name)),
        ZIndex: 1000,
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

export function TestProcedureModal(props) {
    let matchValue, elems_1, elems;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initTest, update_1, (_arg, _arg_1) => {
    }), props.TestRun, undefined);
    const state_1 = patternInput_1[0];
    return createElement(ModalSheet, {
        CloseButtonTestId: "procedure-test-mode-close",
        Content: (matchValue = state_1.ProcedureForm, (matchValue.tag === 0) ? createElement(Skeleton, {
            Variant: "normal",
        }) : reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "grow"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["w-full", "max-w-[51rem]", "px-4", "pt-6"])], ["data-test-id", "procedure-test-mode-banner"], (elems = [createElement(WarningAlert, {
            Label: t("procedure_template.test.banner"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(ProcedureForm, {
            CustomerConfiguration: state_1.CustomerConfiguration,
            Dispatch: patternInput_1[1],
            DocumentUploads: state_1.DocumentUploads,
            FormState: state_1.FormState,
            InspectionDocuments: state_1.InspectionDocuments,
            IsTestMode: true,
            PhotoUploads: state_1.PhotoUploads,
            ProcedureForm: matchValue.fields[0],
            PropertyConfigurations: state_1.PropertyConfigurations,
            SelectedTemplateStep: unwrap(state_1.SelectedTemplateStep),
            StepFiles: state_1.StepFiles,
            Storages: state_1.Storages,
            WriteProcedureStepDto: state_1.WriteProcedureStepDto,
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))),
        Controls: empty_1(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: t("procedure_template.test.title"),
        ZIndex: 1000,
    });
}

